import { getMessageStoragePath } from './getMessageStoragePath'
import { getCanBeThumb } from './getCanBeThumb'
import { THUMB_FILE_NAME_PREFIX } from '../../constants'

interface Props {
  teamId: string
  taskId: string
  messageId: string
  fileName: string
}

export const getMessageThumbPath = ({
  teamId,
  taskId,
  messageId,
  fileName,
}: Props): string | undefined => {
  const path = getMessageStoragePath({ teamId, taskId, messageId })
  const canBeThumb = getCanBeThumb(fileName)

  return canBeThumb ? `${path}${THUMB_FILE_NAME_PREFIX}${fileName}` : undefined
}
